export const DELETE_AA_MEMBERSHIP_MODAL_NAME =
  'DELETE_AA_MEMBERSHIP_MODAL_NAME';
